import { render, staticRenderFns } from "./segmentReportItem.vue?vue&type=template&id=5564c63a"
import script from "./segmentReportItem.vue?vue&type=script&lang=js"
export * from "./segmentReportItem.vue?vue&type=script&lang=js"
import style0 from "./segmentReportItem.vue?vue&type=style&index=0&id=5564c63a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports